import moment from 'moment';

const ISO_DATE_FORMAT = 'YYYY-MM-DD';

export const getNumberParam = (params: URLSearchParams, key: string) => {
  const value = params.get(key);
  if (!value) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const getIsoDateParam = (params: URLSearchParams, key: string) => {
  const value = params.get(key);
  return value && moment(value, ISO_DATE_FORMAT, true).isValid()
    ? value
    : undefined;
};

export const getBooleanParam = (params: URLSearchParams, key: string) =>
  params.get(key) === 'true' ? true : undefined;

export const getEnumParam = <T extends string>(
  params: URLSearchParams,
  key: string,
  allowedValues: readonly T[],
) => {
  const value = params.get(key);
  return allowedValues.find(allowed => allowed === value);
};
